"use client";

import { memo } from "react";
import { DashboardStreamdown as Streamdown } from "./dashboard-streamdown";
import { code } from "@streamdown/code";
import { math } from "@streamdown/math";

const NonMemoizedMarkdown = ({ children }: { children: string }) => {
  return (
    <Streamdown
      plugins={{
        code: code,
        math: math,
      }}
    >
      {children}
    </Streamdown>
  );
};

export const Markdown = memo(
  NonMemoizedMarkdown,
  (prevProps, nextProps) => prevProps.children === nextProps.children
);
